import styled from 'styled-components';
import { PaginationComponent, ModalSubBranchesComponent } from '../../../components/';
import Swal from 'sweetalert2';
import { toReadableDate } from '../../../../utils';

const TableDiv = styled.div`
    opacity: ${(props) => (props.loading ? '0.4' : '1')};
    pointer-events: ${(props) => (props.loading ? 'none' : 'auto')};
`;

const InputStyle = styled.input`
    &:focus {
        // outline: ${(props) => (props.loading ? 'none' : 'auto')};
        box-shadow: ${(props) => (props.loading ? 'none' : 'auto')};
    }
`;

const NoRecordIcon = styled.i`
    font-size: 50px;
    color: grey;
`;

export default function BranchTable({
    SpinnerWrapper,
    setFormData,
    loading,
    setIsLoading,
    branchList,
    tableDetails,
    setSearch,
    handleAddSubBranch,
    handleEdit,
    handleDelete,
    loadBranches,
    modalState,
    setModalState,
    _branchGetOne,
    formData
}) {
    const showSubBranches = (e, data) => {
        console.log('modal passed data: ', data);
        e.preventDefault();
        setModalState({
            isOpen: true,
            data: data,
            formData: null
        });
    };

    return (
        <div>
            <div className="card overflow-auto">
                <div className="card-body">
                    <h5 className="card-title">Branches List</h5>
                    <div>
                        <SpinnerWrapper loading={loading ? 1 : 0}>
                            <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                                style={{ width: '30px', height: '30px' }}
                            ></span>
                        </SpinnerWrapper>
                    </div>

                    <TableDiv loading={loading ? 1 : 0}>
                        <div className="row justify-content-end">
                            <div className="col-6 mb-3">
                                <InputStyle
                                    loading={loading ? 1 : 0}
                                    id="search"
                                    type="text"
                                    className="form-control"
                                    placeholder="Search"
                                    value={tableDetails.search}
                                    onChange={(e) => setSearch(e.target.value)}
                                />
                            </div>
                        </div>

                        <table className="table table-hover">
                            <thead>
                                <tr style={{ borderBottom: '1px solid #dee2e6' }}>
                                    <th scope="col">ID</th>
                                    <th scope="col">Branch Name</th>
                                    <th scope="col">PCC</th>
                                    <th scope="col">PCC Name</th>
                                    <th scope="col">Created</th>
                                    <th scope="col">Last Update</th>
                                    <th scope="col"></th>
                                    <th scope="col"></th>
                                    <th scope="col"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {branchList &&
                                    branchList.map((item, index) => {
                                        return (
                                            <tr key={'user_' + index + item.BRANCH_ID}>
                                                <td scope="row">{item.BRANCH_ID}</td>
                                                <th>
                                                    {!!item.IS_SUB_BRANCH && (
                                                        <span className={`badge bg-secondary me-2`}>Sub</span>
                                                    )}
                                                    <a
                                                        href="#"
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#branchmodal"
                                                        onClick={(e) => showSubBranches(e, item)}
                                                    >
                                                        {item.BRANCH_NAME}
                                                    </a>
                                                </th>
                                                <td>{item.PCC}</td>
                                                <td>{item.PCC_NAME}</td>
                                                <td>{toReadableDate(item.CREATED_AT, 'MMMM dd, yyyy h:mm a')}</td>
                                                <td>{toReadableDate(item.UPDATED_AT, 'MMMM dd, yyyy h:mm a')}</td>
                                                <td width="2%">
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary rounded-pill btn-sm"
                                                        title="Add Sub-Branch"
                                                        onClick={() => handleAddSubBranch(item)}
                                                    >
                                                        <i className="bi bi-plus-lg"></i>
                                                    </button>
                                                </td>
                                                <td width="2%">
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary rounded-pill btn-sm"
                                                        title="Edit"
                                                        onClick={() => handleEdit(item)}
                                                    >
                                                        <i className="bi bi-pencil"></i>
                                                    </button>
                                                </td>
                                                <td width="2%">
                                                    {formData.BRANCH_ID !== item.BRANCH_ID ? (
                                                        <button
                                                            type="button"
                                                            className="btn btn-danger rounded-pill btn-sm"
                                                            title="Delete"
                                                            onClick={() =>
                                                                handleDelete({
                                                                    id: item.BRANCH_ID
                                                                })
                                                            }
                                                        >
                                                            <i className="bi bi-trash"></i>
                                                        </button>
                                                    ) : (
                                                        <i>Editing...</i>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                {!branchList ||
                                    (!branchList.length && (
                                        <tr>
                                            <td colSpan="10" className="text-center p-0">
                                                <div className="p-2" style={{ backgroundColor: '#FAF9F6' }}>
                                                    <NoRecordIcon className="bi bi-exclamation-triangle" />
                                                    <div>No Branches available.</div>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>

                        <PaginationComponent
                            totalData={tableDetails.totalData}
                            currentPage={tableDetails.currentPage}
                            totalPages={tableDetails.totalPages}
                            onPageChange={loadBranches}
                        />

                        <ModalSubBranchesComponent
                            modalState={modalState}
                            setModalState={setModalState}
                            toReadableDate={toReadableDate}
                        />
                    </TableDiv>
                </div>
            </div>
        </div>
    );
}
